import { AdditionalFieldsEndpoints } from './endpoints';
import * as schemas from './schemas';
import { getToken } from '~/apps/shared/services/token';
import * as net from '~/lib/net';
import { AdditionalField } from '../models';
import { AdditionalFieldRequest } from './params';

/**
 additionalFields list
 */

export async function getFieldsByLocationId(locationId: string): Promise<AdditionalField[]> {
  const data = await net.apiGet(AdditionalFieldsEndpoints.getAdditionalFieldsByLocationId(locationId), getToken());
  return schemas.AdditionalFieldListSchema.load(data);
}
export async function getFieldsByOrgId(locationId: string): Promise<AdditionalField[]> {
  const data = await net.apiGet(AdditionalFieldsEndpoints.getAdditionalFieldsByOrgId(locationId), getToken());
  return schemas.AdditionalFieldListSchema.load(data);
}

// Management
export async function addAdditionalField(req: AdditionalFieldRequest): Promise<AdditionalField> {
  const payload = schemas.AdditionalFieldRequest.save(req);

  const data = await net.apiPost(AdditionalFieldsEndpoints.addAdditionalField(), getToken(), payload);
  return (data);
}

export async function updateAdditionalField(fieldId: string, req: AdditionalFieldRequest): Promise<AdditionalField> {
  const payload = schemas.AdditionalFieldRequest.save(req);

  const data = await net.apiPut(AdditionalFieldsEndpoints.updateAdditionalField(fieldId), getToken(), payload);
  return (data);
}

export async function deleteAdditionalField(fieldId: string): Promise<AdditionalField> {
  const data = await net.apiDelete(AdditionalFieldsEndpoints.deleteAdditionalField(fieldId), getToken());
  return (data);
}
